var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_open-external-link","data-name":"Icon open-external-link","d":"M0,0V16H16V12H14v2H2V2H4V0ZM8,0l3,3L6,8l2,2,5-5,3,3V0Z","fill":"#f40"}));
}

ExternalLink.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
